// extracted by mini-css-extract-plugin
export default {"notes":"ThreadColorTabContent_notes__Vz4pu"};